import { createSlice } from '@reduxjs/toolkit';

type PolicyFormType = {
  userId: any;
  familyId: any;
};

const initialState: PolicyFormType = {
  userId: null,
  familyId: null,
};

const caseData = createSlice({
  name: 'caseData',
  initialState,
  reducers: {
    setUserId(state, action) {
      const { payload } = action;
      state.userId = payload;
    },
    setFamilyId(state, action) {
      const { payload } = action;
      state.familyId = payload;
    },
    clearUserId(state) {
      state.userId = null;
    },
    clearFamily(state) {
      state.familyId = null;
    },
  },
});

export const { clearUserId, clearFamily, setUserId, setFamilyId } = caseData.actions;

export default caseData.reducer;
